
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiScreenSplitBottom as ObiScreenSplitBottomElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-screen-split-bottom.js';
 
 
 

 
 export const ObiScreenSplitBottom = createComponent({
   react: React,
   tagName: 'obi-screen-split-bottom',
   elementClass: ObiScreenSplitBottomElement,
   events: {
     
   }
  });
 
 